/* Theme boot: sets data-theme (and data-notes) before first paint. A classic blocking script in <head>, so the page never flashes the wrong theme. The same choices base.js makes after load: the pxke_theme cookie (shared across the public hosts; 'system' means the OS scheme), else the stored theme_mode, else the OS scheme. */
(function () {
  try {
    var c = /(?:^|;\s*)pxke_theme=(light|dark|system)(?:;|$)/.exec(document.cookie)
    var m = c ? c[1] : localStorage.getItem('theme_mode')
    var d = m === 'dark' || (m !== 'light' && window.matchMedia('(prefers-color-scheme: dark)').matches)
    document.documentElement.dataset.theme = d ? 'dark' : 'light'
    if (localStorage.getItem('pxke_notes_hidden') === '1') document.documentElement.dataset.notes = 'hidden'
  } catch (e) {}
})()
